import { HTMLAttributes, memo, PropsWithChildren } from 'react';
import { useDropdown } from '../dropdown.context';
import { ItemEl } from '../dropdown.styled';

type ItemProps = {
  onSelect?: () => void;
  disabled?: boolean;
  critical?: boolean;
  icon?: React.ReactNode;
  _ref?: (el: HTMLElement | null) => void;
  _focused?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const Item = memo(
  ({
    children,
    onSelect,
    disabled,
    critical,
    icon,
    _ref,
    _focused,
    ...rest
  }: PropsWithChildren<ItemProps>) => {
    const { close, closeParent } = useDropdown();

    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation();

      if (disabled) {
        return;
      }
      onSelect?.();
      close();
      closeParent();
    };

    return (
      <ItemEl
        ref={_ref}
        role="menuitem"
        tabIndex={-1}
        $critical={critical}
        onClick={handleClick}
        {...rest}
      >
        {icon && icon}
        {children}
      </ItemEl>
    );
  }
);

Item.displayName = 'Dropdown.Item';
